// //////////////////////////////////////////////////////////////////////////////
// Init Search Client
// //////////////////////////////////////////////////////////////////////////////
function initSearch() {
    const MAX_QUICK_LINKS = 4;
    // const MAX_RECOMMENDED_SEARCHES = 4;

    // jquery autocomplete
    $('.search-field').autocomplete({
        search: '',
        delay: 300,

        source(request) {
            fetch(`/wp-json/hiddenvalleykitchens/v1/relevanssi/?term=${request.term}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    credentials: 'same-origin',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    const { term } = data.data;
                    const { options } = data.data;
                    console.log(data);
                    if (data.status === 0) {
                        $('.js-recommended-searches ul').empty();
                        $('.js-quick-links').empty();
                        if (term) {
                            $('.js-recommended-searches ul').append(`<li>${term}</li>`);
                            $('.js-recommended-searches').removeClass('invisible');
                        }
                        if (options) {
                            let count = 0;
                            $.each(options, (index, option) => {
                                if (count < MAX_QUICK_LINKS) {
                                    $('.js-quick-links').append(
                                        `<li><a href="${option.permalink}">${option.post_title}</a></li>`
                                    );
                                    count += 1;
                                }
                            });
                            $('.js-quick-links--default').addClass('hidden');
                            $('.js-quick-links').removeClass('hidden');
                        }
                    } else {
                        console.log(`search status: ${data.status}`);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },
    });
}

jQuery(document).ready(() => {
    initSearch();
});
